export default function Style(){
  return (
    <style>
      {
        `
        
 .testimonialSlider .slick-list .slick-track .slick-slide {
  width: 348px !important;

}
.testimonialSlider .slick-list .slick-track {
  display: flex !important;
}

.h-box{
  min-height: 112px;
  
}

.testimonialSlider .slick-dots li.slick-active button {
  width: 10px;
  height: 10px;
  background-color: #ffffff;
}

.testimonialSlider .slick-dots li button {
  width: 10px;
  height: 10px;
  background-color: #767676;
  border-radius: 50%;
}

.slider-white .slick-dots li button {
  width: 10px;
  height: 10px;
  background-color: #767676;
}

.slider-white .slick-dots li.slick-active button {
  width: 10px;
  height: 10px;
  background-color: #1B1B1B;
}
.card-shadow {
  box-shadow: rgb(0 0 0 / 18%) 2px 6px 30px 0px !important;
}


.testimonialSlider .left-arrow{
  left: -32px;
  color: black;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}
 .testimonialSlider .right-arrow {
  right: -37px ;
  color: black;
  outline: none;
  position: absolute;
  top: 43%;
  z-index: 1;
}
 
 
 .testimonialSlider .left-arrow .right-arrow {
   font-size: 0;
   line-height: 0;
   position: absolute;
  display: block;
  width: 20px;
  height: 20px;
  padding: 0;
      -webkit-transform: translate(0, -50%);
      -moz-transform: translate(0, -50%);
      transform: translate(0, -50%);
      cursor: pointer;
      color: transparent;
      border: none;
      outline: none;
      background: transparent;
}

.testimonialSlider svg{
  display: inline-block !important;
}
 .testimonialSlider .left-arrow:hover {
  color: black!important;

}
 .testimonialSlider .right-arrow:hover {
  color: black !important;

}
.testi-h{
  min-height: 25px;
}
.testi-h-w{
  min-height: 25px;
}

.h-name{
  min-height:96px;
}





@media only screen and (max-width: 1534px) {
  .fs-16-18 {
    font-size: 16px;
  }
  .fs-16-18 {
    font-size: 16px;
  }
  .fs-16-18 {
    font-size: 16px;
  }
  .fs-16-18 {
    font-size: 16px;
  }
  .fs-18-23 {
    font-size: 16px;
    line-height: 21px;
  }
  .fs-18-23 {
    font-size: 18px;
    line-height: 23px;
  }
  .fs-responsive-18 {
    font-size: 16px !important;
    line-height: 21px;

  }
  .fs-responsive-18 {
    font-size: 18px !important;
    line-height: 23px;
  }
  .fs-responsive-14 {
    font-size: 12px !important;

  }
  .fs-responsive-14 {
    font-size: 14px !important;

  }

  .p-0-5 {
    margin: 5.5px 0px !important;
  }
  .testi-h{
    min-height: 25px;
  }
}



@media only screen and (max-width: 300px) and (min-width: 280px) {
 
  .testimonialSlider {
    padding:0 10px;
  }
  .testi-h{
    min-height: 25px;
  }
}





@media only screen and (min-width: 1024px) {

  .testimonialSlider {
    padding:0 0px;
  }
  .testi-h{
    min-height: 0px;
  }
}

@media only screen and (min-width: 1281px) {
  .testimonialSlider{
    padding: 0 43px;
  }
  .testi-h{
    min-height: 25px;
  }

}

@media only screen and (min-width: 1400px) {
  .testimonialSlider .slick-dots{
    left : 0 !important;
    bottom: 10px !important;
  }
  .testi-h{
    min-height: 25px;
  }
}
.testimonialImg{
  width: 100px !important;
}


.p-0-5 {
  margin: 6.5px 0px;
}
        `
         }
    </style>
  )
}
